// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={224}
    height={160}
    viewBox="0 0 224 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1688_28515"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={30}
      y={9}
      width={102}
      height={92}
    >
      <rect
        x={30.1294}
        y={61.4531}
        width={58.6973}
        height={83.1546}
        transform="rotate(-62.1239 30.1294 61.4531)"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0_1688_28515)">
      <path
        d="M115.563 101.07C105.853 96.992 85.4877 88.5211 67.7905 67.8839L83.6448 53.8073C100.357 73.5162 118.816 79.5738 125.481 82.1503L115.563 101.07Z"
        fill="#FF9DBE"
      />
      <mask
        id="mask1_1688_28515"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={67}
        y={53}
        width={59}
        height={49}
      >
        <path
          d="M115.563 101.07C105.853 96.992 85.4877 88.5211 67.7905 67.8839L83.6448 53.8073C100.357 73.5162 118.816 79.5738 125.481 82.1503L115.563 101.07Z"
          fill="#FF9DBE"
        />
      </mask>
      <g mask="url(#mask1_1688_28515)">
        <path
          d="M76.0654 63.0547C84.6925 55.3968 88.6813 68.7682 115.896 78.342L123.266 75.5306L85.0092 47.0311L76.0654 63.0547Z"
          fill="#FF73A9"
        />
      </g>
      <path
        d="M81.589 57.4442C83.1502 55.6136 83.9445 54.2057 83.5526 53.7493C83.173 53.3064 81.7547 53.8502 79.8277 55.068C78.2569 56.0594 76.3486 57.5013 74.3801 59.2161C72.7815 60.5985 71.2755 62.0853 69.8721 63.6665C68.1775 65.6119 67.2981 67.1196 67.7069 67.5965C68.0808 68.026 69.443 67.5185 71.3084 66.3562C72.9039 65.3617 74.8627 63.892 76.8793 62.1297C78.7687 60.475 80.4015 58.8364 81.589 57.4442Z"
        fill="#FF73A9"
      />
      <path
        d="M83.4581 55.1165C83.0564 55.876 82.3638 56.7689 81.7052 57.5407C80.4734 58.986 78.7956 60.6553 76.981 62.2406C75.0334 63.9421 73.0482 65.4488 71.3919 66.4819C68.7873 68.1058 67.8882 68.0368 67.5939 67.6923C67.0075 67.008 68.4486 65.0687 69.7604 63.5615C71.1664 61.9768 72.6755 60.487 74.2778 59.1021C76.168 57.4501 78.1091 55.9723 79.7444 54.9397C82.4399 53.2376 83.3648 53.2993 83.6652 53.654C83.9252 53.9456 83.7923 54.4847 83.4581 55.1165ZM68.0649 66.3787C67.7427 66.9879 67.7015 67.3449 67.823 67.4903C68.0428 67.7467 69.0658 67.5684 71.228 66.2202C72.8727 65.1961 74.8439 63.7006 76.7794 62.0089C78.5832 60.4329 80.2503 58.7753 81.4712 57.3417C83.2963 55.2 83.6716 54.1219 83.4349 53.8473C83.1983 53.5727 82.149 53.7788 79.9071 55.1949C78.2848 56.2181 76.3567 57.6866 74.4786 59.3288C72.8867 60.706 71.3874 62.1874 69.9906 63.7632C68.9904 64.9081 68.3876 65.7686 68.0649 66.3787Z"
        fill="#29292F"
      />
      <path
        d="M78.7491 33.2903C76.9341 32.6361 74.9984 33.6893 74.2035 35.4561C72.5731 39.0793 72.3027 44.2976 72.3027 44.2976C68.6499 39.7392 65.5987 35.0751 64.0417 31.2396C63.3877 29.6274 61.7631 28.5283 60.0532 28.8449C59.5423 28.9363 59.0572 29.139 58.6325 29.4388C58.2077 29.7386 57.8535 30.1281 57.5951 30.5797C57.3366 31.0313 57.1801 31.534 57.1368 32.0522C57.0934 32.5704 57.1642 33.0915 57.3441 33.5784C58.5714 36.8921 62.404 42.4433 65.3723 46.4832L65.1348 46.6924C62.2523 43.7116 57.922 38.8898 52.4043 34.653C51.0141 33.5863 48.9838 33.5945 47.7139 34.811C47.3393 35.1651 47.0458 35.5962 46.8535 36.0746C46.6613 36.553 46.5751 37.0673 46.6007 37.5817C46.6263 38.0961 46.7633 38.5984 47.0021 39.0538C47.2409 39.5091 47.5757 39.9067 47.9835 40.2189C53.3833 44.3493 58.0094 49.0066 60.694 51.8075L60.6811 51.8319L60.6332 51.9224L60.5293 52.0992C58.4932 50.3387 54.8699 47.6854 52.2688 46.2447C50.6903 45.3704 48.6275 45.6845 47.5512 47.1414C47.2458 47.5502 47.0316 48.0198 46.9232 48.5183C46.8148 49.0168 46.8147 49.5325 46.9229 50.0303C47.0312 50.5281 47.2452 50.9963 47.5504 51.4031C47.8556 51.8099 48.2449 52.1458 48.6918 52.3878C54.5799 55.5799 60.1764 59.0417 69.9594 67.124C72.9105 65.7216 80.1842 59.8136 82.9533 55.6713C79.3163 51.9577 78.3141 46.2597 80.7543 38.1738C81.3483 36.1827 80.7879 34.027 78.7491 33.2903Z"
        fill="#FFD5E1"
      />
      <path
        d="M68.4541 44.2662C65.8925 46.0948 62.4505 48.9682 60.5897 52.2923C59.4804 54.2738 59.4643 55.4887 59.468 55.5034L59.1616 55.5047C59.1615 55.4525 59.1731 54.2179 60.3108 52.1738C61.3493 50.3065 63.5759 47.3751 68.2813 44.0172L68.4541 44.2662Z"
        fill="#29292F"
      />
      <path
        d="M83.1417 55.6606L83.0693 55.7648C80.0693 60.1279 73.0217 65.8462 70.0143 67.2698L69.9265 67.3114L69.8518 67.2499C60.3976 59.4446 54.9044 55.9424 48.609 52.5302C48.1438 52.2784 47.7384 51.9292 47.4201 51.5062C47.1019 51.0832 46.8782 50.5964 46.7642 50.0786C46.6511 49.5583 46.6509 49.0193 46.7638 48.4981C46.8766 47.977 47.0998 47.4859 47.4181 47.058C48.5124 45.5759 50.625 45.1722 52.3332 46.1175C54.8815 47.5291 58.4292 50.1181 60.4806 51.8716L60.5003 51.8345C58.7563 50.0189 53.7514 44.8322 47.8859 40.3477C47.4623 40.0233 47.1142 39.6106 46.8655 39.1379C46.6169 38.6652 46.4735 38.1437 46.4454 37.6094C46.4183 37.0711 46.508 36.5328 46.7083 36.0318C46.9086 35.5308 47.2147 35.0788 47.6056 34.7071C48.9021 33.4664 51.0042 33.3944 52.4953 34.5387C57.2031 38.1537 61.055 42.1941 63.8631 45.1518C64.3155 45.6228 64.7399 46.0789 65.1412 46.4893L65.1678 46.4652C62.1833 42.397 58.4139 36.9139 57.203 33.6368C57.0155 33.13 56.9412 32.5878 56.9854 32.0483C57.0295 31.5089 57.191 30.9853 57.4586 30.5144C57.7284 30.0416 58.0983 29.6336 58.5423 29.3193C58.9862 29.005 59.4933 28.7921 60.0277 28.6956C61.7248 28.3792 63.4731 29.4256 64.1856 31.1822C65.6083 34.6872 68.4401 39.1924 72.1793 43.8972C72.2844 42.6079 72.7015 38.4275 74.0662 35.3959C74.9389 33.456 76.9753 32.4896 78.8014 33.1509C79.2814 33.3145 79.7178 33.5851 80.0779 33.9423C80.438 34.2995 80.7125 34.7341 80.8808 35.2134C81.2042 36.105 81.2071 37.177 80.889 38.2298C78.5725 45.9073 79.3001 51.7427 83.053 55.5732L83.1417 55.6606ZM69.9719 66.9508C72.6658 65.629 79.5765 60.2263 82.7464 55.6948C78.987 51.7786 78.2634 45.8723 80.5963 38.1398C81.3488 35.6417 80.1857 33.9757 78.6984 33.4393C77.0234 32.8348 75.1518 33.7297 74.3453 35.5227C72.7449 39.0784 72.4608 44.257 72.4577 44.3087L72.4539 44.3901L72.3844 44.4321C72.3436 44.4568 68.3167 46.9966 69.1454 51.9472L68.8433 51.9993C68.0715 47.3882 71.3452 44.7871 72.0816 44.2673C68.2555 39.4759 65.3535 34.8745 63.9033 31.2993C63.2445 29.6766 61.6373 28.7106 60.0837 28.9975C59.5934 29.0862 59.1281 29.2816 58.7206 29.5699C58.3132 29.8582 57.9735 30.2324 57.7256 30.666C57.4802 31.0979 57.332 31.5782 57.2916 32.073C57.2511 32.5678 57.3193 33.0651 57.4914 33.5299C58.7006 36.8038 62.5131 42.334 65.4996 46.3962L65.5827 46.5097L65.124 46.9123L65.0224 46.8076C64.5945 46.3646 64.1298 45.8779 63.6419 45.365C60.8385 42.4179 56.9984 38.3837 52.3094 34.7832C50.9367 33.7293 49.0055 33.7922 47.8179 34.9295C47.4594 35.2708 47.1787 35.6857 46.9952 36.1456C46.8117 36.6055 46.7297 37.0995 46.7549 37.5936C46.7809 38.0841 46.9127 38.5629 47.1413 38.9968C47.3699 39.4307 47.6898 39.8094 48.079 40.1069C54.0557 44.6757 59.1379 49.9693 60.8094 51.706L60.8895 51.7901L60.564 52.3443L60.4245 52.2242C58.4112 50.4816 54.7798 47.8217 52.1905 46.3872C50.6174 45.5158 48.6734 45.8823 47.6703 47.24C47.3757 47.6313 47.1695 48.0819 47.0659 48.5605C46.9624 49.0391 46.9641 49.5342 47.0708 50.0114C47.1752 50.4869 47.3805 50.9339 47.6728 51.3222C47.9651 51.7105 48.3376 52.0309 48.7649 52.2617C55.0498 55.6718 60.5449 59.1726 69.9719 66.9508Z"
        fill="#29292F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.5166 69.138C52.1538 70.6467 53.2916 71.8883 54.7381 72.6534C56.1846 73.4185 57.8513 73.6603 59.457 73.338L59.5116 73.6129C57.8427 73.9479 56.1104 73.6966 54.607 72.9014C53.1035 72.1062 51.9209 70.8157 51.2586 69.2476L51.5166 69.138Z"
        fill="#29292F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.0071 66.7559C54.4564 67.9222 55.3242 68.8779 56.4409 69.4365L56.443 69.4375L56.445 69.4385C57.2731 69.8868 58.2051 70.108 59.1468 70.0797C59.4542 70.0663 59.7593 70.0187 60.0563 69.9377L60.1294 70.2083C59.812 70.2948 59.4861 70.3457 59.1575 70.3599L59.1566 70.36L59.1557 70.36C58.1651 70.3899 57.1847 70.1575 56.3134 69.6863C55.1353 69.0965 54.2198 68.0878 53.7458 66.8572L54.0071 66.7559Z"
        fill="#29292F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.0216 22.4327C77.6905 22.0977 79.4228 22.349 80.9262 23.1442C82.4297 23.9395 83.6123 25.23 84.2746 26.7981L84.0166 26.9076C83.3794 25.399 82.2416 24.1573 80.7951 23.3922C79.3486 22.6271 77.6819 22.3854 76.0762 22.7077L76.0216 22.4327Z"
        fill="#29292F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.2283 26.3643C78.0777 25.7224 76.7288 25.5333 75.4447 25.8341L75.5081 26.1071C76.7249 25.8221 78.0034 26.0016 79.0935 26.6104L79.0955 26.6115L79.0975 26.6125C79.9341 27.0448 80.6414 27.6907 81.1481 28.485C81.31 28.7467 81.4423 29.0257 81.5425 29.3168L81.8073 29.225C81.7002 28.9139 81.5588 28.6158 81.3857 28.3362L81.3852 28.3354L81.3847 28.3347C80.8519 27.499 80.1081 26.8194 79.2283 26.3643Z"
        fill="#29292F"
      />
    </g>
    <path
      d="M64.3839 121.009L64.2203 120.878C63.4847 120.289 62.5459 120.017 61.6102 120.119C60.6744 120.222 59.8181 120.692 59.2294 121.426L59.1221 121.56L58.7724 121.323L58.8982 121.166C59.4893 120.437 59.7684 119.503 59.6749 118.569C59.6293 118.108 59.4916 117.661 59.27 117.255C59.0483 116.849 58.7473 116.491 58.3846 116.203L58.6169 115.913C59.9801 117.004 62.0284 117.268 63.5153 115.409L63.6428 115.25L63.9432 115.54L63.8598 115.669C62.8273 117.26 63.1043 119.448 64.4771 120.548L64.6061 120.651L64.3839 121.009Z"
      fill="white"
    />
    <path
      d="M64.3839 121.009L64.2203 120.878C63.4847 120.289 62.5459 120.017 61.6102 120.119C60.6744 120.222 59.8181 120.692 59.2294 121.426L59.1221 121.56L58.7724 121.323L58.8982 121.166C59.4893 120.437 59.7684 119.503 59.6749 118.569C59.6293 118.108 59.4916 117.661 59.27 117.255C59.0483 116.849 58.7473 116.491 58.3846 116.203L58.6169 115.913L58.6173 115.913C59.9804 117.004 62.0284 117.268 63.5153 115.409L63.6428 115.25L63.9432 115.54L63.8598 115.669C62.8273 117.26 63.1043 119.448 64.4771 120.548L64.6061 120.651L64.3839 121.009ZM59.7686 120.42C60.31 120.047 60.9361 119.816 61.5899 119.748C62.2437 119.68 62.9044 119.776 63.5118 120.028C63.1688 119.482 62.9553 118.865 62.8873 118.224C62.8194 117.584 62.8989 116.936 63.1199 116.331C62.6163 116.744 62.0084 117.011 61.3628 117.102C60.7173 117.193 60.0589 117.104 59.4599 116.846C59.7851 117.354 59.9856 117.932 60.0451 118.532C60.1105 119.174 60.0155 119.823 59.7686 120.42Z"
      fill="#29292F"
    />
    <path
      d="M34.1294 87.3305L33.8569 87.5977L53.4387 107.566L53.7112 107.299L34.1294 87.3305Z"
      fill="#29292F"
    />
    <path
      d="M40.8537 101.885L40.6016 102.172L53.0972 113.168L53.3493 112.881L40.8537 101.885Z"
      fill="#29292F"
    />
    <rect
      x={40.7734}
      y={133.105}
      width={73.2125}
      height={4.94889}
      rx={1.80417}
      fill="#ABE3FF"
      stroke="#29292F"
      strokeWidth={0.515478}
    />
    <path
      d="M40.7734 135.449H112.683C113.403 135.449 113.986 136.032 113.986 136.752C113.986 137.471 113.403 138.055 112.683 138.055H42.5775C41.5811 138.055 40.7734 137.247 40.7734 136.251V135.449Z"
      fill="#29A9FF"
      stroke="#29292F"
      strokeWidth={0.515478}
    />
    <path
      d="M98.7612 58.9302C99.1948 57.0613 100.86 55.7383 102.778 55.7383H213.587C216.241 55.7383 218.204 58.2088 217.604 60.794L200.361 135.122C199.927 136.99 198.262 138.313 196.344 138.313H85.5352C82.8813 138.313 80.9183 135.843 81.5181 133.258L98.7612 58.9302Z"
      fill="#29292F"
    />
    <g clipPath="url(#clip0_1688_28515)">
      <g clipPath="url(#clip1_1688_28515)">
        <path
          d="M101.61 58.9722C102.024 57.1877 103.614 55.9243 105.446 55.9243H216.254C218.788 55.9243 220.663 58.2834 220.09 60.752L202.847 135.08C202.433 136.864 200.843 138.127 199.011 138.127H88.2027C85.6685 138.127 83.7941 135.768 84.3668 133.3L101.61 58.9722Z"
          fill="#ABE3FF"
          stroke="#29292F"
          strokeWidth={0.372086}
        />
        <mask
          id="path-22-outside-1_1688_28515"
          maskUnits="userSpaceOnUse"
          x={131.259}
          y={102.762}
          width={23.1244}
          height={26.0526}
          fill="black"
        >
          <rect
            fill="white"
            x={131.259}
            y={102.762}
            width={23.1244}
            height={26.0526}
          />
          <path d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z" />
        </mask>
        <path
          d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z"
          fill="#C8FBE7"
        />
        <path
          d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z"
          stroke="#FCFBF7"
          strokeWidth={3.93348}
          strokeLinejoin="round"
          mask="url(#path-22-outside-1_1688_28515)"
        />
        <mask
          id="path-23-outside-2_1688_28515"
          maskUnits="userSpaceOnUse"
          x={133.991}
          y={105.494}
          width={18.1603}
          height={21.4545}
          fill="black"
        >
          <rect
            fill="white"
            x={133.991}
            y={105.494}
            width={18.1603}
            height={21.4545}
          />
          <path d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z" />
        </mask>
        <path
          d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z"
          fill="#C8FBE7"
        />
        <path
          d="M134.893 110.59C136.898 109.432 139.282 109.118 141.519 109.718C143.756 110.317 145.664 111.781 146.822 113.787C147.98 115.792 148.293 118.176 147.694 120.413C147.095 122.65 145.631 124.558 143.625 125.716L142.373 123.546C143.803 122.721 144.847 121.36 145.275 119.765C145.702 118.169 145.478 116.469 144.652 115.039C143.827 113.609 142.466 112.565 140.871 112.137C139.275 111.71 137.575 111.934 136.145 112.759L134.893 110.59Z"
          stroke="#29292F"
          strokeWidth={0.744173}
          mask="url(#path-23-outside-2_1688_28515)"
        />
        <rect
          x={187.95}
          y={66.2734}
          width={13.4705}
          height={13.0623}
          rx={2.65776}
          transform="rotate(42.2152 187.95 66.2734)"
          fill="white"
        />
        <rect
          x={188.244}
          y={68.8839}
          width={9.72974}
          height={9.45992}
          rx={1.40861}
          transform="rotate(42.2152 188.244 68.8839)"
          fill="#FFE6ED"
          stroke="#29292F"
          strokeWidth={0.372086}
        />
        <rect
          x={117.326}
          y={86.7031}
          width={9.16349}
          height={8.88581}
          rx={2.65776}
          transform="rotate(42.2152 117.326 86.7031)"
          fill="white"
        />
        <rect
          x={117.528}
          y={88.5636}
          width={6.49981}
          height={6.31627}
          rx={1.40861}
          transform="rotate(42.2152 117.528 88.5636)"
          fill="#FFE6ED"
          stroke="#29292F"
          strokeWidth={0.372086}
        />
        <circle
          cx={110.988}
          cy={119.348}
          r={10.0777}
          transform="rotate(-45 110.988 119.348)"
          fill="#FFE9A4"
          stroke="#FCFBF7"
          strokeWidth={1.59466}
        />
        <circle
          cx={110.988}
          cy={119.348}
          r={9.09434}
          transform="rotate(-45 110.988 119.348)"
          fill="#FFE9A4"
          stroke="#29292F"
          strokeWidth={0.372086}
        />
        <circle
          cx={107.7}
          cy={121.078}
          r={1.02948}
          transform="rotate(-45 107.7 121.078)"
          fill="#29292F"
          stroke="#29292F"
          strokeWidth={0.143954}
        />
        <circle
          cx={112.718}
          cy={116.059}
          r={1.02948}
          transform="rotate(-45 112.718 116.059)"
          fill="#29292F"
          stroke="#29292F"
          strokeWidth={0.143954}
        />
        <circle
          cx={108.897}
          cy={123.637}
          r={0.840159}
          transform="rotate(-45 108.897 123.637)"
          fill="#FFB743"
        />
        <circle
          cx={115.276}
          cy={117.258}
          r={0.840159}
          transform="rotate(-45 115.276 117.258)"
          fill="#FFB743"
        />
        <path
          d="M112.412 118.933C112.517 119.038 112.597 119.165 112.647 119.308C112.698 119.451 112.718 119.607 112.706 119.766C112.695 119.926 112.652 120.086 112.58 120.237C112.509 120.389 112.41 120.529 112.289 120.65C112.168 120.771 112.028 120.87 111.876 120.942C111.724 121.013 111.564 121.056 111.405 121.067C111.245 121.079 111.09 121.059 110.947 121.008C110.804 120.958 110.676 120.878 110.572 120.773"
          stroke="#29292F"
          strokeWidth={0.372086}
          strokeLinecap="round"
        />
      </g>
      <path
        d="M170.597 119.543L173.539 124.357C173.751 124.704 174.258 124.694 174.456 124.339L176.569 120.552C176.584 120.525 176.597 120.497 176.607 120.468L182.395 103.87L170.597 119.543Z"
        fill="#FCFBF7"
      />
      <path
        d="M182.395 103.87L164.553 117.66C164.184 117.945 164.334 118.532 164.793 118.606L170.597 119.543L182.395 103.87Z"
        fill="#FCFBF7"
      />
      <path
        d="M182.395 103.87L181.162 120.665C181.14 120.975 180.855 121.2 180.548 121.15L174.105 120.11L182.395 103.87Z"
        fill="#FCFBF7"
      />
      <path
        d="M175.843 120.391C176.207 120.45 176.402 120.852 176.222 121.174L175.048 123.279C174.779 123.763 174.042 123.564 174.052 123.011L174.105 120.11L175.843 120.391Z"
        fill="#FCFBF7"
      />
      <path
        d="M170.597 119.543L173.539 124.357C173.751 124.704 174.258 124.694 174.456 124.339L176.569 120.552C176.584 120.525 176.597 120.497 176.607 120.468L182.395 103.87M170.597 119.543L182.395 103.87M170.597 119.543L164.793 118.606C164.334 118.532 164.184 117.945 164.553 117.66L182.395 103.87M182.395 103.87L181.162 120.665C181.14 120.975 180.855 121.2 180.548 121.15L174.105 120.11M182.395 103.87L174.105 120.11M174.105 120.11L174.052 123.011C174.042 123.564 174.779 123.763 175.048 123.279L176.222 121.174C176.402 120.852 176.207 120.45 175.843 120.391L174.105 120.11Z"
        stroke="#FCFBF7"
        strokeWidth={3.72086}
        strokeLinejoin="round"
      />
      <path
        d="M170.597 119.544L174.013 125.135L176.592 120.513L182.395 103.871L170.597 119.544Z"
        fill="#75F5C4"
        stroke="#29292F"
        strokeWidth={0.372086}
        strokeLinejoin="bevel"
      />
      <path
        d="M182.395 103.87L163.582 118.41L170.597 119.543L182.395 103.87Z"
        fill="#C8FBE7"
        stroke="#29292F"
        strokeWidth={0.372086}
        strokeLinejoin="round"
      />
      <path
        d="M182.395 103.872L181.121 121.245L174.106 120.112L182.395 103.872Z"
        fill="#FCFBF7"
        stroke="#29292F"
        strokeWidth={0.372086}
        strokeLinejoin="round"
      />
      <path
        d="M176.591 120.513L174.013 125.135L174.104 120.111L176.591 120.513Z"
        fill="#38D695"
        stroke="#29292F"
        strokeWidth={0.372086}
        strokeLinejoin="bevel"
      />
      <path
        d="M145.787 72.058L145.787 72.058L150.893 75.1401L156.745 73.99C157.822 73.7784 158.758 74.7479 158.509 75.8163L157.156 81.6247L160.058 86.8349C160.592 87.7933 159.959 88.9833 158.866 89.0766L158.775 88.0174L158.866 89.0766L152.923 89.5843L148.865 93.9545L148.086 93.2311L148.865 93.9545C148.119 94.7584 146.791 94.5244 146.365 93.5137L144.046 88.0191L138.635 85.5098C137.64 85.0482 137.452 83.7136 138.282 82.9956L138.978 83.7994L138.282 82.9956L142.791 79.092L143.505 73.171M145.787 72.058L143.505 73.171M145.787 72.058C144.848 71.4911 143.637 72.0819 143.505 73.171M145.787 72.058L143.505 73.171M143.505 73.171L144.554 73.2975M143.505 73.171L144.554 73.2975M143.505 73.171L144.554 73.2975M143.505 73.171L144.554 73.2975"
        fill="#FFD074"
        stroke="#FCFBF7"
        strokeWidth={2.12621}
      />
      <path
        d="M145.334 72.8089C144.94 72.5709 144.431 72.8189 144.376 73.2761L143.633 79.4328C143.625 79.4976 143.594 79.5571 143.544 79.5998L138.856 83.6587C138.508 83.9601 138.586 84.5204 139.004 84.7141L144.63 87.3233C144.689 87.3507 144.736 87.3992 144.761 87.4594L147.173 93.1727C147.352 93.5969 147.909 93.6952 148.222 93.3577L152.442 88.8136C152.487 88.7658 152.547 88.7362 152.612 88.7307L158.791 88.2028C159.25 88.1636 159.516 87.664 159.292 87.2617L156.274 81.8441C156.242 81.7871 156.233 81.7203 156.247 81.6568L157.655 75.6172C157.759 75.1687 157.366 74.7618 156.914 74.8506L150.829 76.0465C150.765 76.059 150.699 76.0473 150.643 76.0136L145.334 72.8089Z"
        stroke="#29292F"
        strokeWidth={0.372086}
      />
      <path
        d="M146.122 76.2144C146.145 76.0253 146.355 75.9227 146.518 76.0211L150.103 78.1848C150.238 78.2664 150.398 78.2947 150.553 78.2642L154.661 77.4568C154.848 77.4201 155.011 77.5884 154.968 77.774L154.018 81.8516C153.982 82.0052 154.004 82.1667 154.081 82.3044L156.119 85.9622C156.211 86.1286 156.102 86.3352 155.912 86.3515L151.74 86.7079C151.583 86.7213 151.436 86.7928 151.329 86.9083L148.48 89.9763C148.35 90.1159 148.12 90.0753 148.046 89.8998L146.418 86.0424C146.356 85.8971 146.243 85.7798 146.1 85.7135L142.302 83.9519C142.129 83.8717 142.096 83.64 142.24 83.5153L145.406 80.7749C145.525 80.6717 145.602 80.5277 145.62 80.3711L146.122 76.2144Z"
        fill="#FFE9A4"
        stroke="#29292F"
        strokeWidth={0.372086}
      />
    </g>
    <path
      d="M100.808 30.4736L100.613 30.3941C99.8435 30.0806 98.981 30.0852 98.2153 30.4067C97.4495 30.7283 96.843 31.3407 96.5289 32.1094L96.4643 32.2681L96.0668 32.1421L96.1429 31.9554C96.4599 31.19 96.462 30.3301 96.1487 29.5623C95.9947 29.184 95.7662 28.8403 95.4767 28.5519C95.1873 28.2634 94.8429 28.036 94.4639 27.8832L94.3144 27.8222L94.4186 27.4059L94.6172 27.487C95.3598 27.8135 96.1955 27.8593 96.9687 27.6158C97.3592 27.4724 97.7137 27.2455 98.0073 26.9508C98.3009 26.6562 98.5265 26.301 98.6685 25.9099L99.0192 26.0332C98.5445 27.6393 99.3275 29.4232 100.764 30.0099L100.917 30.0721L100.808 30.4736Z"
      fill="white"
    />
    <path
      d="M100.808 30.4736L100.613 30.3941C99.8435 30.0806 98.981 30.0852 98.2153 30.4067C97.4495 30.7283 96.843 31.3407 96.5289 32.1094L96.4643 32.2681L96.0668 32.1421L96.1429 31.9554C96.4599 31.19 96.462 30.3301 96.1487 29.5623C95.9947 29.184 95.7662 28.8403 95.4767 28.5519C95.1873 28.2634 94.8429 28.036 94.4639 27.8832L94.3144 27.8222L94.4186 27.4059L94.6172 27.487C95.3598 27.8135 96.1955 27.8593 96.9687 27.6158C97.3592 27.4724 97.7137 27.2455 98.0073 26.9508C98.3009 26.6562 98.5265 26.301 98.6685 25.9099L99.0192 26.0332C98.5445 27.6393 99.3275 29.4232 100.764 30.0099L100.917 30.0721L100.808 30.4736ZM96.7455 31.0379C97.109 30.6073 97.5708 30.2703 98.092 30.0554C98.6132 29.8405 99.1785 29.754 99.7404 29.8031C99.3432 29.4403 99.0279 28.9969 98.8157 28.5027C98.6034 28.0084 98.4992 27.4747 98.5098 26.9372C98.1485 27.4124 97.6552 27.7706 97.0913 27.9671C96.5966 28.1338 96.0701 28.1847 95.5524 28.1158C95.9653 28.4702 96.2877 28.9179 96.4929 29.4217C96.7034 29.9346 96.7888 30.4902 96.7418 31.0423L96.7455 31.0379Z"
      fill="#29292F"
    />
    <path
      d="M126.396 29.6815L124.401 28.0352L122.754 30.0298L124.749 31.6761L126.396 29.6815Z"
      fill="#29292F"
    />
    <path
      d="M124.627 31.8259L122.632 30.1796L122.606 29.911L124.253 27.9163L124.522 27.8906L126.517 29.537L126.542 29.8057L124.896 31.8002L124.627 31.8259ZM123.022 30.0067L124.723 31.4102L126.127 29.7099L124.426 28.3063L123.022 30.0067Z"
      fill="#29292F"
    />
    <path
      d="M128.09 29.4069L130.95 31.7674L127.659 35.7544L124.798 33.3939C124.499 33.1471 124.31 32.7918 124.274 32.4059C124.237 32.0201 124.355 31.6353 124.601 31.3364L126.032 29.6037C126.279 29.3048 126.634 29.1161 127.02 29.0792C127.406 29.0423 127.791 29.1602 128.09 29.4069Z"
      fill="#29A9FF"
    />
    <path
      d="M127.538 35.9019L124.677 33.5413C124.34 33.262 124.127 32.8603 124.085 32.4242C124.043 31.9882 124.177 31.5534 124.455 31.2153L125.885 29.4826C126.165 29.145 126.566 28.932 127.003 28.8903C127.439 28.8486 127.874 28.9817 128.212 29.2602L131.072 31.6206L131.098 31.8893L127.807 35.8762L127.538 35.9019ZM124.92 33.2471L127.634 35.4862L130.682 31.7935L127.969 29.5545C127.709 29.3402 127.374 29.2378 127.039 29.2699C126.703 29.302 126.394 29.4658 126.179 29.7255L124.749 31.4582C124.535 31.7181 124.432 32.0526 124.464 32.3881C124.496 32.7235 124.66 33.0325 124.92 33.2471Z"
      fill="#29292F"
    />
    <path
      d="M164.46 62.043L163.588 63.0985L165.661 63.9221L164.46 62.043Z"
      fill="#29292F"
    />
    <path
      d="M160.837 56.4883L164.43 62.1065L163.653 62.968L157.503 60.5255L160.837 56.4883Z"
      fill="#29A9FF"
    />
    <path
      d="M163.582 63.1456L157.432 60.7031L157.356 60.4044L160.689 56.3672L160.997 56.3859L164.59 62.004L164.571 62.2344L163.794 63.096L163.582 63.1456ZM157.817 60.4453L163.599 62.7421L164.19 62.087L160.816 56.8121L157.817 60.4453Z"
      fill="#29292F"
    />
    <path
      d="M160.912 56.4904L129.796 30.8125L126.463 34.8497L157.579 60.5275L160.912 56.4904Z"
      fill="#F4F3ED"
    />
    <path
      d="M157.602 60.7528L157.478 60.6506L126.238 34.8706L129.775 30.5859L129.899 30.6881L161.139 56.4682L157.602 60.7528ZM126.689 34.8273L157.558 60.301L160.687 56.5114L129.818 31.0377L126.689 34.8273Z"
      fill="#29292F"
    />
    <path
      d="M128.355 32.5572L128.112 32.8516L136.923 40.1233L137.166 39.8289L128.355 32.5572Z"
      fill="#29292F"
    />
    <path
      d="M150.358 15.1055H149.976V43.0728H150.358V15.1055Z"
      fill="#29292F"
    />
    <path
      d="M154.584 35.2422H154.203V46.6902H154.584V35.2422Z"
      fill="#29292F"
    />
    <path
      d="M211.858 19.7278L211.52 19.5508L198.548 44.3279L198.886 44.5049L211.858 19.7278Z"
      fill="#29292F"
    />
    <path
      d="M209.54 34.2239L209.202 34.0469L201.578 48.6084L201.916 48.7853L209.54 34.2239Z"
      fill="#29292F"
    />
    <path
      d="M187.053 42.1266L174.835 33.705L179.555 28.5469L191.252 36.6102C191.252 36.6102 187.617 40.5708 187.15 41.0941C187.018 41.2289 186.937 41.4051 186.919 41.5931C186.901 41.7811 186.949 41.9694 187.053 42.1266Z"
      fill="#FF960B"
    />
    <path
      d="M186.962 42.259L174.744 33.8374L174.717 33.5959L179.436 28.4379L179.646 28.4141L191.343 36.4774L191.371 36.7191C191.334 36.7586 187.731 40.6847 187.27 41.2012C187.161 41.3078 187.093 41.4493 187.077 41.6012C187.061 41.7531 187.099 41.9057 187.184 42.0325L186.962 42.259ZM175.079 33.6771L186.756 41.7258C186.749 41.5904 186.77 41.4551 186.817 41.3281C186.864 41.201 186.937 41.0849 187.03 40.9866C187.443 40.5237 190.364 37.3399 191.009 36.6376L179.579 28.7588L175.079 33.6771Z"
      fill="#29292F"
    />
    <path
      d="M184.468 39.4313L184.207 39.2423L189.374 32.0941C189.519 31.883 189.735 31.7311 189.982 31.6661C190.229 31.6012 190.492 31.6274 190.721 31.7401C190.969 31.8605 191.805 32.2242 192.184 31.8418C192.248 31.784 192.299 31.7126 192.333 31.6329C192.367 31.5532 192.383 31.4671 192.38 31.3805C192.36 30.9853 191.961 30.4736 191.161 29.8158C189.882 28.7646 189.133 28.5135 188.575 28.9491C188.294 29.1686 188.389 29.5025 188.567 30.029C188.756 30.5889 188.619 31.0389 188.194 31.27L179.538 35.8768L179.388 35.5924L188.042 30.9863C188.397 30.7931 188.359 30.4188 188.265 30.1389C188.085 29.6083 187.902 29.0664 188.378 28.6949C189.246 28.0168 190.327 28.7132 191.365 29.5669C192.251 30.2953 192.676 30.8664 192.701 31.3641C192.707 31.4955 192.684 31.6265 192.634 31.7482C192.584 31.8698 192.508 31.9792 192.412 32.0687C191.916 32.5698 191.051 32.2593 190.581 32.0297C190.419 31.951 190.235 31.933 190.062 31.9791C189.889 32.0251 189.738 32.1321 189.637 32.2804L184.468 39.4313Z"
      fill="#29292F"
    />
    <path
      d="M191.252 36.6084L190.574 33.3664L178.465 25.0195L179.554 28.545L191.252 36.6084Z"
      fill="#29292F"
    />
    <path
      d="M191.16 36.7408L179.462 28.6775L179.4 28.5924L178.311 25.067L178.555 24.8867L190.664 33.2336L190.731 33.3332L191.409 36.5751L191.16 36.7408ZM179.691 28.4439L191.012 36.2475L190.429 33.4624L178.755 25.4152L179.691 28.4439Z"
      fill="#29292F"
    />
    <path
      d="M190.574 33.3652L178.58 25.0977L173.873 31.949L185.868 40.2166L190.574 33.3652Z"
      fill="#FFB743"
    />
    <path
      d="M185.776 40.3491L173.782 32.0815L173.74 31.8575L178.447 25.0062L178.67 24.9648L190.665 33.2324L190.706 33.4564L186 40.3078L185.776 40.3491ZM174.096 31.9075L185.826 39.9925L190.35 33.4065L178.621 25.3214L174.096 31.9075Z"
      fill="#29292F"
    />
    <path
      d="M183.129 38.5486L182.826 38.4417L187.17 26.0671C187.278 25.7431 187.495 25.4668 187.784 25.2854C188.073 25.1039 188.416 25.0284 188.755 25.0718C189.539 25.1918 190.328 25.1983 190.796 24.4409C191.589 23.1571 190.056 21.9208 189.071 21.2981C187.367 20.2206 185.985 20.1149 185.373 21.0155C184.86 21.7697 185.163 22.4421 185.528 23.0004C185.71 23.2818 185.792 23.6171 185.758 23.951C185.725 24.2848 185.578 24.5973 185.344 24.8367L176.307 34.314L176.075 34.0915L185.113 24.612C185.297 24.4251 185.412 24.1809 185.438 23.9199C185.465 23.6589 185.401 23.3967 185.259 23.1767C184.892 22.6148 184.477 21.7606 185.107 20.8342C185.829 19.7727 187.375 19.8443 189.243 21.0257C191.09 22.1936 191.755 23.5002 191.069 24.6103C190.425 25.654 189.22 25.4691 188.706 25.3902C188.442 25.3582 188.174 25.4189 187.949 25.5619C187.725 25.705 187.556 25.9216 187.473 26.175L183.129 38.5486Z"
      fill="#29292F"
    />
    <path
      d="M173.74 31.459L173.705 31.5007C173.585 31.4529 173.454 31.438 173.326 31.4576C173.199 31.4771 173.079 31.5303 172.978 31.6117C172.824 31.7174 172.718 31.8795 172.682 32.0631C172.646 32.2467 172.683 32.4371 172.786 32.5932L184.747 40.5281L185.938 39.5599L173.74 31.459Z"
      fill="#FFB743"
    />
    <path
      d="M184.658 40.6637L172.697 32.7289L172.661 32.6961C172.383 32.3527 172.48 31.8108 172.877 31.488C172.994 31.392 173.134 31.3279 173.283 31.302C173.433 31.2761 173.586 31.2893 173.729 31.3403L173.828 31.3261L186.026 39.427L186.039 39.6862L184.848 40.6544L184.658 40.6637ZM172.897 32.4752L184.737 40.3298L185.666 39.5743L173.714 31.6367L173.651 31.6539C173.557 31.6158 173.454 31.6035 173.354 31.6183C173.253 31.6331 173.159 31.6744 173.079 31.7381C172.963 31.8161 172.879 31.9349 172.846 32.0712C172.812 32.2076 172.83 32.3517 172.897 32.4752Z"
      fill="#29292F"
    />
    <path
      d="M185.746 40.542C186.075 40.2746 186.161 39.8352 185.938 39.5605C185.716 39.2858 185.269 39.2799 184.94 39.5472C184.611 39.8145 184.525 40.2539 184.748 40.5286C184.97 40.8033 185.417 40.8093 185.746 40.542Z"
      fill="#29292F"
    />
    <path
      d="M185.217 40.8978L185.205 40.8977C185.094 40.9002 184.984 40.8773 184.883 40.8305C184.782 40.7838 184.693 40.7146 184.623 40.6282C184.553 40.5418 184.504 40.4404 184.479 40.3319C184.454 40.2234 184.454 40.1107 184.48 40.0023C184.528 39.7723 184.655 39.5664 184.839 39.4203C185.019 39.2691 185.246 39.1866 185.481 39.1877C185.592 39.1852 185.703 39.2081 185.803 39.2548C185.904 39.3015 185.993 39.3708 186.063 39.4572C186.133 39.5436 186.183 39.645 186.208 39.7534C186.233 39.8619 186.232 39.9747 186.207 40.0831C186.159 40.3132 186.032 40.519 185.848 40.6651C185.67 40.8126 185.448 40.8947 185.217 40.8978ZM185.469 39.5097C185.312 39.5153 185.16 39.5726 185.039 39.6728C184.917 39.773 184.831 39.9105 184.795 40.0642C184.779 40.1263 184.777 40.1913 184.791 40.254C184.804 40.3167 184.832 40.3754 184.873 40.4252C184.913 40.475 184.965 40.5146 185.023 40.5407C185.082 40.5668 185.146 40.5788 185.21 40.5756L185.217 40.5757C185.375 40.5701 185.526 40.5128 185.648 40.4126C185.77 40.3124 185.855 40.1749 185.892 40.0211C185.908 39.9591 185.909 39.8941 185.896 39.8314C185.882 39.7686 185.854 39.71 185.814 39.6602C185.773 39.6104 185.722 39.5708 185.663 39.5447C185.605 39.5186 185.541 39.5066 185.477 39.5098L185.469 39.5097Z"
      fill="#29292F"
    />
    <path
      d="M187.871 41.967C188.174 41.7207 188.269 41.336 188.084 41.1077C187.899 40.8793 187.503 40.8938 187.201 41.1401C186.898 41.3863 186.802 41.771 186.987 41.9994C187.173 42.2277 187.568 42.2132 187.871 41.967Z"
      fill="#29292F"
    />
    <path
      d="M187.361 42.3201C187.267 42.3234 187.173 42.3053 187.086 42.2672C187 42.2291 186.923 42.172 186.862 42.1C186.621 41.8032 186.727 41.316 187.098 41.0142C187.469 40.7125 187.967 40.7081 188.208 41.0053C188.449 41.3022 188.342 41.7893 187.971 42.0911V42.0912C187.8 42.2347 187.585 42.3155 187.361 42.3201ZM187.71 41.1058C187.56 41.1113 187.416 41.167 187.301 41.2641C187.072 41.4509 186.985 41.7407 187.111 41.897C187.238 42.0536 187.539 42.0276 187.769 41.841C187.998 41.6544 188.085 41.3646 187.958 41.2083C187.927 41.1736 187.889 41.1465 187.846 41.1287C187.803 41.111 187.756 41.1032 187.71 41.1058Z"
      fill="#29292F"
    />
    <path
      d="M190.77 105.361C190.751 105.158 190.911 104.983 191.114 104.983H220.451C220.654 104.983 220.814 105.158 220.795 105.361L217.163 143.911C217.149 144.053 217.051 144.169 216.917 144.203C215.692 144.51 211.348 145.489 205.783 145.489C200.217 145.489 195.874 144.51 194.648 144.203C194.514 144.169 194.416 144.053 194.402 143.911L190.77 105.361Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.372086}
    />
    <mask
      id="path-75-inside-3_1688_28515"
      fill="white"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.389 135.141L191.313 113.109H220.252L218.176 135.141H193.389Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.389 135.141L191.313 113.109H220.252L218.176 135.141H193.389Z"
      fill="#29A9FF"
    />
    <path
      d="M193.389 135.141L193.018 135.176L193.05 135.513H193.389V135.141ZM191.313 113.109V112.737H190.904L190.943 113.144L191.313 113.109ZM220.252 113.109L220.622 113.144L220.66 112.737H220.252V113.109ZM218.176 135.141V135.513H218.515L218.546 135.176L218.176 135.141ZM193.759 135.106L191.683 113.074L190.943 113.144L193.018 135.176L193.759 135.106ZM191.313 113.481H220.252V112.737H191.313V113.481ZM219.881 113.074L217.806 135.106L218.546 135.176L220.622 113.144L219.881 113.074ZM218.176 134.769H193.389V135.513H218.176V134.769Z"
      fill="#29292F"
      mask="url(#path-75-inside-3_1688_28515)"
    />
    <path
      d="M191.981 100.333C191.981 100.154 192.119 100.004 192.297 99.9886L219.233 97.6496C219.435 97.632 219.609 97.7912 219.609 97.9938V102.719C219.609 102.91 219.454 103.065 219.263 103.065H192.327C192.136 103.065 191.981 102.91 191.981 102.719V100.333Z"
      fill="#E0DDD5"
      stroke="#29292F"
      strokeWidth={0.372086}
    />
    <rect
      x={188.855}
      y={102.022}
      width={34.1853}
      height={3.09079}
      rx={0.345509}
      fill="#F4F3ED"
      stroke="#29292F"
      strokeWidth={0.372086}
    />
    <circle
      cx={205.783}
      cy={124.123}
      r={8.30654}
      fill="#FCFBF7"
    />
    <circle
      cx={205.783}
      cy={124.122}
      r={7.25273}
      fill="#FFE9A4"
      stroke="#29292F"
      strokeWidth={0.372086}
    />
    <path
      d="M208.524 121.016L207.918 121.103L207.917 121.103C207.187 121.209 206.52 121.574 206.036 122.131C205.553 122.689 205.285 123.401 205.282 124.138L205.282 124.139C205.283 124.647 205.101 125.138 204.769 125.522C204.438 125.906 203.98 126.159 203.478 126.234C203.478 126.234 203.478 126.234 203.477 126.234L202.384 126.389C201.85 125.173 202.302 123.394 203.663 122.015C204.489 121.193 205.473 120.697 206.392 120.554C207.212 120.426 207.968 120.579 208.524 121.016Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeWidth={0.372086}
      strokeLinejoin="round"
    />
    <path
      d="M205.167 127.694C204.363 127.819 203.62 127.673 203.067 127.255L203.614 127.177L203.615 127.177C204.345 127.069 205.011 126.703 205.494 126.145C205.977 125.588 206.244 124.876 206.246 124.139C206.251 123.635 206.436 123.149 206.767 122.77C207.099 122.39 207.555 122.142 208.054 122.07C208.054 122.07 208.054 122.07 208.054 122.07L209.187 121.907C209.714 123.104 209.25 124.885 207.896 126.235C207.07 127.057 206.086 127.552 205.167 127.694Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeWidth={0.372086}
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_1688_28515">
        <rect
          width={138.432}
          height={82.5752}
          fill="white"
          transform="translate(83.0127 55.7383)"
        />
      </clipPath>
      <clipPath id="clip1_1688_28515">
        <rect
          width={138.432}
          height={82.5752}
          fill="white"
          transform="translate(83.0127 55.7383)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgGetToKnowDemostack = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgGetToKnowDemostack;
